import "./news.scss";
import template from "./news.html";
import {Base} from "../base";
import {Options} from "vue-class-component";


@Options({
    template,
})
export class News extends Base {
    posts: any[] = [];

    /** Lifecycle */
    created() {
        this.init().catch(this.errorHandle);
    }

    /** Methods */
    async init() {
        this.posts = this.$wp?.data?.posts
    }
}
